import { createFileRoute } from '@tanstack/react-router'
import { DsrListPage } from '../../../features/privacy/dsr-list-page'
import { dsrSearchSchema } from '../../../features/privacy/search'

export const Route = createFileRoute('/_app/privacy-requests/')({
  validateSearch: dsrSearchSchema,
  component: DsrListPage,
})
